module.exports = __webpack_public_path__ + "static/media/new-user.18862738.svg";